'use client';
import React from 'react';
import {
  User, Users, Building2, GraduationCap, Trophy, Briefcase, Sparkles
} from 'lucide-react';

const audiences = [
  {
    icon: User,
    title: 'Real Estate Agents',
    desc: 'Solo agents who want to work smarter, market better, and close more deals without burning out.',
    color: '#00D4FF',
    bg: 'rgba(0,212,255,0.07)',
    border: 'rgba(0,212,255,0.15)',
    iconBg: 'rgba(0,212,255,0.12)',
    iconBorder: 'rgba(0,212,255,0.20)',
  },
  {
    icon: Users,
    title: 'Teams',
    desc: 'Growing teams that need consistent branding, shared tools, and AI-powered productivity across every member.',
    color: '#A78BFA',
    bg: 'rgba(167,139,250,0.07)',
    border: 'rgba(167,139,250,0.15)',
    iconBg: 'rgba(167,139,250,0.12)',
    iconBorder: 'rgba(167,139,250,0.20)',
  },
  {
    icon: Building2,
    title: 'Brokerages',
    desc: 'Brokerages that want to provide agents with enterprise-grade AI tools and maintain brand consistency.',
    color: '#00D4FF',
    bg: 'rgba(0,212,255,0.05)',
    border: 'rgba(0,212,255,0.12)',
    iconBg: 'rgba(0,212,255,0.10)',
    iconBorder: 'rgba(0,212,255,0.18)',
  },
  {
    icon: GraduationCap,
    title: 'New Agents',
    desc: 'New agents who need a competitive edge from day one—professional marketing and AI guidance without the learning curve.',
    color: '#22C55E',
    bg: 'rgba(34,197,94,0.06)',
    border: 'rgba(34,197,94,0.12)',
    iconBg: 'rgba(34,197,94,0.10)',
    iconBorder: 'rgba(34,197,94,0.18)',
  },
  {
    icon: Trophy,
    title: 'Top Producers',
    desc: 'High-volume agents who need automation and AI to scale their business without adding overhead.',
    color: '#F59E0B',
    bg: 'rgba(245,158,11,0.06)',
    border: 'rgba(245,158,11,0.12)',
    iconBg: 'rgba(245,158,11,0.10)',
    iconBorder: 'rgba(245,158,11,0.18)',
  },
  {
    icon: Briefcase,
    title: 'Marketing Coordinators',
    desc: 'Marketing pros who support agents and teams and need powerful AI tools to create content at scale.',
    color: '#A78BFA',
    bg: 'rgba(167,139,250,0.05)',
    border: 'rgba(167,139,250,0.12)',
    iconBg: 'rgba(167,139,250,0.10)',
    iconBorder: 'rgba(167,139,250,0.18)',
  },
];

export default function WhoItsForSection() {
  return (
    <section id="for-teams" className="py-24 relative overflow-hidden" style={{ background: '#0B0F19' }}>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 60% 40% at 30% 60%, rgba(167,139,250,0.04) 0%, transparent 70%)' }}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <div className="section-badge mb-4">
            <Sparkles size={12} />
            Who It's For
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4"
            style={{ color: '#F0F4FF' }}
          >
            Built for every{' '}
            <span className="gradient-cyan-lavender-text">real estate professional</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: 'rgba(240,244,255,0.55)' }}>
            Whether you're just starting out or running a top-producing team, AgentOS scales with your business.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences?.map((audience) => (
            <div
              key={audience?.title}
              className="rounded-2xl p-7 card-hover cursor-default"
              style={{
                background: audience?.bg,
                border: `1px solid ${audience?.border}`,
              }}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                style={{
                  background: audience?.iconBg,
                  border: `1px solid ${audience?.iconBorder}`,
                }}
              >
                <audience.icon size={22} style={{ color: audience?.color }} />
              </div>
              <h3 className="text-lg font-bold mb-2" style={{ color: '#F0F4FF' }}>{audience?.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(240,244,255,0.60)' }}>{audience?.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
